
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommExchangeItemsGrid extends Serenity.EntityGrid<ECommExchangeItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommExchangeItems'; }
        protected getDialogType() { return ECommExchangeItemsDialog; }
        protected getIdProperty() { return ECommExchangeItemsRow.idProperty; }
        protected getInsertPermission() { return ECommExchangeItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommExchangeItemsRow.localTextPrefix; }
        protected getService() { return ECommExchangeItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        } 
        
    }
}